export enum VehicleAndTravelDetailsMessages {
  noActiveTravel = "vehicleAndTravelDetails.noActiveTravel",
  noActiveTravelDescription = "vehicleAndTravelDetails.needActiveTravel",
  noDescriptionRegistered = "vehicleAndTravelDetails.noDescriptionRegistered",
  construction = "vehicleAndTravelDetails.construction",
  alertsTitle = "vehicleAndTravelDetails.alertsTitle",
  noAlertsOnTravel = "vehicleAndTravelDetails.noAlertsOnTravel",
  currentLoad = "vehicleAndTravelDetails.currentLoad",
  waterAdded = "vehicleAndTravelDetails.waterAdded",
  litersAdded = "vehicleAndTravelDetails.addedLiters",
  noWaterAdded = "vehicleAndTravelDetails.noWaterAdded",
  travelStatus = "vehicleAndTravelDetails.travelStatus",
  mapPosition = "vehicleAndTravelDetails.mapPosition",
  allocation = "vehicleAndTravelDetails.allocation",
  lockVehicle = "vehicleAndTravelDetails.lockVehicle",
  unlockVehicle = "vehicleAndTravelDetails.unlockVehicle",
  readWaterAdditionsSuccess = "vehicleAndTravelDetails.readWaterAdditionsSuccess",
  noWaterAdditionsFound = "vehicleAndTravelDetails.noWaterAdditionsFound",
  readWaterAdditionsError = "vehicleAndTravelDetails.readWaterAdditionsError",
  waterAdditionPostDischarge = "vehicleAndTravelDetails.waterAdditionPostDischarge",
  waterAdditionPreDischarge = "vehicleAndTravelDetails.waterAdditionPreDischarge",
  waterAdditionReassignedTitle = "vehicleAndTravelDetails.waterAdditionReassignedTitle",
  waterAdditionReassignedBadge = "vehicleAndTravelDetails.waterAdditionReassignedBadge",
  waterAdditionOriginTravel = "vehicleAndTravelDetails.waterAdditionOriginTravel",
  waterAdditionReassignedAwayTitle = "vehicleAndTravelDetails.waterAdditionReassignedAwayTitle",
  waterAdditionDestinationTravel = "vehicleAndTravelDetails.waterAdditionDestinationTravel",
  waterAdditionAutomaticTravel = "vehicleAndTravelDetails.waterAdditionAutomaticTravel",
  invalidWaterAdditionFilter = "vehicleAndTravelDetails.invalidWaterAdditionFilter"
}

export type TranslationVehicleAndTravelDetailsMessages = {
  [key in VehicleAndTravelDetailsMessages]: string;
}
